import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'data-fetching-client';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import unescapedText from 'I18n/utils/unescapedText';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import FeatureCompatibilityMatrix from 'ecosystem-marketplace-core/compatibility/components/FeatureCompatibilityMatrix'; // @ts-expect-error untyped dependency

import LoadingWrapper from 'ecosystem-marketplace-core/components/LoadingWrapper';
import { GET_COMPATIBILITY } from '../../queries/compatibilityQuery'; // @ts-expect-error untyped dependency

import { getIsCustomer } from '../../selectors/auth';
export default function FeatureCompatibilityModal({
  onClose,
  assetScopes,
  trackInteraction
}) {
  const isCustomer = useSelector(getIsCustomer);
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_COMPATIBILITY, {
    variables: {
      offeringType: 'THEME'
    }
  });
  const compatibilityPortalData = useMemo(() => {
    const compatibilityData = data || previousData;

    if (!compatibilityData) {
      return {
        compatibility: {},
        portalTiers: []
      };
    } else {
      return compatibilityData.compatibility;
    }
  }, [data, previousData]);
  const features = useMemo(() => {
    const compatibilityData = compatibilityPortalData.compatibility;
    return assetScopes.reduce((acc, scope) => {
      const scopeFeatureI18nKey = `marketplace-assets-ui.scopeFeatures.${scope}-title`;

      if (isValidI18nKey(scopeFeatureI18nKey) && scope in compatibilityData) {
        const feature = {
          text: I18n.text(scopeFeatureI18nKey),
          tiers: compatibilityData[scope]
        };
        return acc.concat(feature);
      }

      return acc;
    }, []);
  }, [compatibilityPortalData, assetScopes]);
  const compatibilityRequestState = useMemo(() => {
    if (loading) {
      return RequestStates.PENDING;
    }

    if (error) {
      return RequestStates.FAILED;
    }

    if (!data && !previousData) {
      return RequestStates.UNINITIALIZED;
    }

    return RequestStates.SUCCEEDED;
  }, [data, error, loading, previousData]);
  return /*#__PURE__*/_jsxs(UIModal, {
    width: "90%",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'marketplace-assets-ui.themes.details.requirements.featureCompatibilityModal.header'
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      className: "p-all-0",
      children: /*#__PURE__*/_jsx(LoadingWrapper, {
        requestStatus: compatibilityRequestState,
        children: /*#__PURE__*/_jsx(FeatureCompatibilityMatrix, {
          features: features,
          featureType: unescapedText('marketplace-assets-ui.themes.details.requirements.featureCompatibilityModal.featureType'),
          isCustomer: isCustomer,
          portalTiers: compatibilityPortalData.portalTiers,
          tierGroupNames: ['CRM', 'CMS', 'MARKETING', 'OPERATIONS', 'SALES', 'SERVICE'],
          trackPricingLinkClick: tierGroup => trackInteraction('click compatibility modal pricing link', {
            section: 'overview',
            tierGroup
          })
        })
      })
    })]
  });
}